"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* ======================================================================================================== */

/* SRC/JS/MAIN.JS */

/* ======================================================================================================== */

/* store information about the device */
var Device = {
  touch: false,
  screenWidth: 0,
  screenHeight: 0,
  pixelRes: 1,
  parallax: false,
  initScreenHeight: 0,
  init: function init() {
    /* Detect touch device */
    if ('ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
      Device.touch = true;
      document.body.classList.add('state-touch');
    } else {
      document.body.classList.add('state-no-touch');
    }
    /* Get pixel res */


    Device.pixelRes = window.devicePixelRatio;
    Device.chrome = navigator.userAgent.indexOf('Chrome') > -1;
    Device.explorer = navigator.userAgent.indexOf('MSIE') > -1;
    Device.firefox = navigator.userAgent.indexOf('Firefox') > -1;
    Device.safari = navigator.userAgent.indexOf("Safari") > -1;
    Device.opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;

    if (Device.chrome && Device.safari) {
      Device.safari = false;
    }

    if (Device.chrome && Device.opera) {
      Device.chrome = false;
    }

    if (Device.safari === true || Device.touch === true) {
      Device.parallax = false;
      document.body.classList.add('state-no-parallax');
    } else {
      document.body.classList.add('state-parallax');

      if (Device.chrome) {
        document.body.classList.add('state-parallax-full');
      }
    }

    Device.refresh();
  },

  /* called on resize to collect information about the viewport */
  refresh: function refresh() {
    if (Device.screenWidth !== window.innerWidth && Device.touch === true) {
      Device.screenHeight = window.innerHeight;
    } else if (Device.touch === false) {
      Device.screenHeight = window.innerHeight;
    }

    if (Device.screenHeight === 0) {
      Device.screenHeight = window.innerHeight;
    }

    Device.screenWidth = window.innerWidth;
    Device.realScreenHeight = window.innerHeight;

    var _vh = Device.screenHeight * 0.01;

    document.documentElement.style.setProperty('--vh', _vh + 'px');

    var _rvh = Device.realScreenHeight * 0.01;

    document.documentElement.style.setProperty('--rvh', _rvh + 'px');
  }
};
var Scroll = {
  heightForcer: null,
  siteWrap: null,
  wrapHeight: 0,
  lastScrollPos: -1,
  scrollPos: 0,
  adjustScrollPos: 0,
  posOffset: 0,
  maxScrollPos: 0,
  pImgRatio: 1.375,
  fixedEls: [],
  loadObs: [],
  pImgObs: [],
  resizing: false,
  scrollDown: true,
  scrolledToTop: false,
  headerEl: null,
  menuButtonEl: null,
  headerScrollUp: false,
  headerAtTop: true,
  headerTimer: null,
  hasSplash: false,
  shopButton: null,
  init: function init() {
    Scroll.heightForcer = document.getElementById('js-height-forcer');
    Scroll.siteWrap = document.getElementsByClassName('c-site-wrapper')[0];
    /* Call the resize event to set everything up */

    Scroll.doResize();
  },
  setupPage: function setupPage() {
    Scroll.fixedEls = document.getElementsByClassName('js-fixed-el');
    Scroll.heightForcer.style.display = 'none';

    if (Device.parallax === true) {
      Scroll.heightForcer.style.display = 'block';
      Scroll.wrapHeight = Scroll.siteWrap.clientHeight;
      Scroll.heightForcer.style.height = Scroll.wrapHeight + 'px';
      Scroll.siteWrap.classList.add('state-parallax-fixed');
      Scroll.maxScrollPos = Math.floor(Scroll.wrapHeight - Device.screenHeight);
    } else {
      Scroll.siteWrap.classList.remove('state-parallax-fixed');
      Scroll.siteWrap.removeAttribute('style');

      for (var _i = 0; _i < Scroll.fixedEls.length; _i++) {
        Scroll.fixedEls[_i].removeAttribute('style');
      }
    }
  },
  doPage: function doPage() {
    if (Device.parallax === true && Menu.open === false) {
      Scroll.siteWrap.style.transform = 'translate3d(0px,' + (0 - Scroll.scrollPos) + 'px,0px)';

      for (var _i = 0; _i < Scroll.fixedEls.length; _i++) {
        Scroll.fixedEls[_i].style.transform = 'translate3d(0px,' + Scroll.scrollPos + 'px,0px)';
      }
    }
  },
  doScroll: function doScroll() {
    Scroll.lastScrollPos = Scroll.scrollPos;

    var _newPos = Math.floor(window.pageYOffset);

    if (Boot.pageLoaded === false) {
      _newPos = 0;
    }

    if (Menu.open === false) {
      if (_newPos < Scroll.scrollPos) {
        if (Scroll.scrollDown !== false) {
          document.body.classList.add('state-scroll-up');
        }

        Scroll.scrollDown = false;
      } else {
        if (Scroll.scrollDown !== true) {
          document.body.classList.remove('state-scroll-up');
        }

        Scroll.scrollDown = true;
      }

      if (_newPos > 3) {
        if (Scroll.scrolledToTop !== false) {
          document.body.classList.remove('state-scrolled-top');
        }

        Scroll.scrolledToTop = false;
      } else {
        if (Scroll.scrolledToTop !== true) {
          document.body.classList.add('state-scrolled-top');
        }

        Scroll.scrolledToTop = true;
      }

      Scroll.scrollPos = _newPos;

      if (Device.portrait === false && Device.touch === false) {
        Scroll.posOffset = Scroll.scrollPos;
      } else {
        Scroll.posOffset = 0;
      }
    }
  },
  getLoadOffset: function getLoadOffset() {
    Scroll.loadObs = [];

    var _main = document.querySelector('main');

    var _loadEls = document.getElementsByClassName('js-scroll-load');

    if (_loadEls) {
      for (var _i = 0; _i < _loadEls.length; _i++) {
        Scroll.loadObs[_i] = [];
        Scroll.loadObs[_i]['el'] = _loadEls[_i];
        Scroll.loadObs[_i]['offset'] = Helper.getOffsetTop(Scroll.loadObs[_i]['el']) - Device.screenHeight * 4;

        if (Boot.pageLoaded === false && Helper.getOffsetTop(Scroll.loadObs[_i]['el']) < Device.screenHeight * 1.25 && _main.contains(Scroll.loadObs[_i]['el'])) {
          Scroll.loadObs[_i]['el'].classList.add('js-state-load-first');
        }

        if (Scroll.loadObs[_i]['el'].classList.contains('js-state-load-media')) {
          Scroll.loadObs[_i]['loaded'] = true;
        } else {
          Scroll.loadObs[_i]['loaded'] = false;
        }
      }
    }
  },
  doLoad: function doLoad() {
    if (Scroll.loadObs) {
      for (var _i = 0; _i < Scroll.loadObs.length; _i++) {
        if (Scroll.loadObs[_i]['offset'] < Scroll.scrollPos && Scroll.loadObs[_i]['loaded'] === false && Boot.pageLoaded === true) {
          Scroll.loadObs[_i]['el'].classList.add('js-state-load-media');

          Scroll.loadObs[_i]['loaded'] = true;
          LoadMedia.doLoad(Scroll.loadObs[_i]['el']);
        }
      }
    }
  },
  getParallax: function getParallax() {
    Scroll.parallaxObs = [];

    var _parents = document.getElementsByClassName('js-parallax-parent');

    if (_parents) {
      for (var _i = 0; _i < _parents.length; _i++) {
        if (_parents[_i].classList.contains('js-setup') === false) {
          _parents[_i].classList.add('js-setup');

          var _children = _parents[_i].querySelectorAll('h1,h2,h3,h4,h5,h6,p,li,hr, small, .c-button, .c-media__inner, .flag');

          if (_children) {
            for (var _j = 0; _j < _children.length; _j++) {
              _children[_j].classList.add('js-parallax');
            }
          }
        }
      }
    }

    var _els = document.getElementsByClassName('js-parallax');

    if (_els) {
      var _j2 = 0;

      for (var _i2 = 0; _i2 < _els.length; _i2++) {
        if (Helper.getOffsetLeft(_els[_i2]) < Device.screenWidth) {
          Scroll.parallaxObs[_j2] = [];
          Scroll.parallaxObs[_j2]['el'] = _els[_i2];
          Scroll.parallaxObs[_j2]['el'].style.transform = 'translate3d(0px,0px,0px)';
          var _speed = 0.4;

          var _speedAdjust = Helper.getOffsetLeft(Scroll.parallaxObs[_j2]['el']) / Device.screenWidth;

          _speed = _speed * _speedAdjust + 0.1;
          var _adjust = 0.6;
          Scroll.parallaxObs[_j2]['end'] = Math.floor(Helper.getOffsetTop(Scroll.parallaxObs[_j2]['el']) - Device.screenHeight * _adjust);
          Scroll.parallaxObs[_j2]['speed'] = _speed;
          Scroll.parallaxObs[_j2]['start'] = Math.floor(Scroll.parallaxObs[_j2]['end'] - Device.screenHeight);
          Scroll.parallaxObs[_j2]['finished'] = false;
          Scroll.parallaxObs[_j2]['endless'] = Scroll.parallaxObs[_j2]['el'].classList.contains('js-parallax--endless');
          Scroll.parallaxObs[_j2]['image'] = Scroll.parallaxObs[_j2]['el'].classList.contains('js-parallax--image');

          if (Scroll.parallaxObs[_j2]['endless'] === true) {
            Scroll.parallaxObs[_j2]['speed'] = 0.125;
            Scroll.parallaxObs[_j2]['end'] = Math.floor(Helper.getOffsetTop(Scroll.parallaxObs[_j2]['el']) - Device.screenHeight * 0.5);
            Scroll.parallaxObs[_j2]['start'] = Scroll.parallaxObs[_j2]['end'] - Device.screenHeight;
          }

          if (Scroll.parallaxObs[_j2]['image'] === true) {
            Scroll.parallaxObs[_j2]['speed'] = 0.5;
            Scroll.parallaxObs[_j2]['endless'] = true;
            Scroll.parallaxObs[_j2]['end'] = Math.floor(Helper.getOffsetTop(Scroll.parallaxObs[_j2]['el']));
            Scroll.parallaxObs[_j2]['start'] = Math.floor(Scroll.parallaxObs[_j2]['end'] - Device.screenHeight);
          }

          _j2 = _j2 + 1;
        } else {
          _els[_i2].style.transform = 'none';
        }
      }

      ;
    }
  },
  doParallax: function doParallax() {
    for (var _i = 0; _i < Scroll.parallaxObs.length; _i++) {
      var _offset = 0;

      if (Scroll.scrollPos > Scroll.parallaxObs[_i]['end'] && Scroll.parallaxObs[_i]['finished'] === false) {
        if (Scroll.parallaxObs[_i]['endless'] === true && Device.parallax === true) {
          _offset = Math.floor((Scroll.scrollPos - Scroll.parallaxObs[_i]['end']) * Scroll.parallaxObs[_i]['speed']);
          Scroll.parallaxObs[_i]['el'].style.willChange = 'transform';
          Scroll.parallaxObs[_i]['el'].style.transform = 'translate3d(0px,' + _offset + 'px,0px)';
        } else {
          Scroll.parallaxObs[_i]['el'].style.transform = 'translate3d(0px,0px,0px)';
          Scroll.parallaxObs[_i]['finished'] = true;

          Scroll.parallaxObs[_i]['el'].classList.add('state-parallax-done');
        }
      } else if (Scroll.scrollPos >= Scroll.parallaxObs[_i]['start'] && Scroll.scrollPos <= Scroll.parallaxObs[_i]['end']) {
        Scroll.parallaxObs[_i]['finished'] = false;

        Scroll.parallaxObs[_i]['el'].classList.remove('state-parallax-done');

        if (Device.parallax === true) {
          if (Scroll.parallaxObs[_i]['endless'] === true) {
            _offset = Math.floor((Scroll.scrollPos - Scroll.parallaxObs[_i]['end']) * Scroll.parallaxObs[_i]['speed']);
          } else {
            _offset = Math.abs(Math.floor((Scroll.scrollPos - Scroll.parallaxObs[_i]['end']) * Scroll.parallaxObs[_i]['speed']));
          }

          Scroll.parallaxObs[_i]['el'].style.willChange = 'transform';
          Scroll.parallaxObs[_i]['el'].style.transform = 'translate3d(0px,' + _offset + 'px,0px)';
        }
      } else if (Scroll.parallaxObs[_i]['finished'] === false) {
        if (Scroll.parallaxObs[_i]['endless'] === true && Device.parallax === true) {
          _offset = Math.floor((Scroll.scrollPos - Scroll.parallaxObs[_i]['end']) * Scroll.parallaxObs[_i]['speed']);
          Scroll.parallaxObs[_i]['el'].style.willChange = 'transform';
          Scroll.parallaxObs[_i]['el'].style.transform = 'translate3d(0px,' + _offset + 'px,0px)';
        } else {
          Scroll.parallaxObs[_i]['el'].style.transform = 'translate3d(0px,0px,0px)';
          Scroll.parallaxObs[_i]['finished'] = true;

          Scroll.parallaxObs[_i]['el'].classList.add('state-parallax-done');
        }
      }
    }
  },
  getParallaxImg: function getParallaxImg() {
    Scroll.pImgObs = [];

    if (Device.parallax === true) {
      var _pImgEls = document.getElementsByClassName('js-img-parallax');

      for (var _i = 0; _i < _pImgEls.length; _i++) {
        Scroll.pImgObs[_i] = [];
        Scroll.pImgObs[_i]['el'] = _pImgEls[_i];

        var _height = Math.ceil(Scroll.pImgObs[_i]['el'].parentElement.clientHeight);

        var _imgHeight = Math.ceil(_height * Scroll.pImgRatio);

        var _offset = Helper.getOffsetTop(Scroll.pImgObs[_i]['el'].parentElement);

        var _midPoint = _offset + _height * 0.5 - Device.screenHeight * 0.5;

        Scroll.pImgObs[_i]['el'].style.position = 'absolute';
        Scroll.pImgObs[_i]['el'].style.width = '100%';
        Scroll.pImgObs[_i]['el'].style.height = _imgHeight + 'px';
        Scroll.pImgObs[_i]['el'].style.top = '0';
        Scroll.pImgObs[_i]['el'].style.left = '0';
        Scroll.pImgObs[_i]['start'] = Math.floor(_midPoint - Device.screenHeight * 1 - 16);
        Scroll.pImgObs[_i]['end'] = Math.ceil(_midPoint + Device.screenHeight * 1 + 16);
        Scroll.pImgObs[_i]['height'] = _height;
        Scroll.pImgObs[_i]['imgHeight'] = _imgHeight;
      }
    }
  },
  doParallaxImg: function doParallaxImg() {
    if (Device.parallax === true) {
      for (var _i = 0; _i < Scroll.pImgObs.length; _i++) {
        if (Scroll.scrollPos < Scroll.pImgObs[_i]['start']) {
          Scroll.pImgObs[_i]['el'].style.transform = 'translate3d(0px,' + (Scroll.pImgObs[_i]['height'] - Scroll.pImgObs[_i]['imgHeight']) + 'px,0px)';
        } else if (Scroll.scrollPos > Scroll.pImgObs[_i]['end']) {
          Scroll.pImgObs[_i]['el'].style.transform = 'translate3d(0px,0px,0px)';
        } else {
          var _ratio = (Scroll.pImgObs[_i]['end'] - Scroll.scrollPos) / (Scroll.pImgObs[_i]['end'] - Scroll.pImgObs[_i]['start']);

          var _offset = 0 - Math.round((Scroll.pImgObs[_i]['imgHeight'] - Scroll.pImgObs[_i]['height']) * _ratio);

          Scroll.pImgObs[_i]['el'].style.transform = 'translate3d(0px,' + _offset + 'px,0px)';
        }
      }
    }
  },
  doResize: function doResize() {
    Scroll.resizing = true;
    Scroll.setupPage();
    Scroll.doScroll();
    Scroll.getParallax();
    Scroll.getParallaxImg();
    Scroll.getLoadOffset();
    Scroll.lastScrollPos = -1;
    Scroll.resizing = false;
  }
};
/* Dynamically load media */

var LoadMedia = {
  totalBrackets: 5,
  loadFirst: function loadFirst() {
    var _els = document.getElementsByClassName('js-state-load-first');

    Array.from(_els).forEach(function (_el) {
      LoadMedia.doLoad(_el);
    });
  },
  doResize: function doResize() {
    var _els = document.getElementsByClassName('state-media-loaded');

    if (_els) {
      for (var _i = 0; _i < _els.length; _i++) {
        if (_els[_i].getElementsByTagName('img').length > 0) {
          var _loadedSrc = _els[_i].getElementsByTagName('img')[0].getAttribute('src');

          var _targetSrc = LoadMedia.findSrc(_els[_i]);

          if (_loadedSrc !== _targetSrc) {
            _els[_i].classList.remove('state-load-called');

            _els[_i].classList.remove('js-state-load-media');

            _els[_i].classList.remove('state-media-loaded');
          }
        }
      }
    }
  },
  doLoad: function doLoad(_el) {
    if (_el.classList.contains('state-load-called') === false) {
      _el.classList.add('state-load-called');

      var _doLoad = true;

      var _src = LoadMedia.findSrc(_el);

      if (_el.getElementsByTagName('img').length > 0) {
        if (_el.getElementsByTagName('img')[0].getAttribute('src') == _src) {
          _doLoad = false;
        }
      }

      if (_doLoad === true) {
        var _img = new Image();

        _img.onload = function () {
          setTimeout(function () {
            _el.classList.add('state-media-loaded');

            if (_el.getElementsByTagName('img').length > 1) {
              _el.getElementsByTagName('img')[0].remove();
            }

            Boot.checkLoader();
          }, 100);
        };

        _img.src = _src;

        _el.appendChild(_img);
      } else {
        _el.classList.add('state-media-loaded');
      }
    }
  },
  findSrc: function findSrc(_el) {
    var _src = '';

    var _width = _el.clientWidth * Device.pixelRes;

    var _height = _el.clientHeight * Device.pixelRes;

    var _bracket = -1;

    var _bracketCount = 0;

    for (var _i = 0; _i < LoadMedia.totalBrackets; _i++) {
      var _bracketWidth = _el.getAttribute('data-img-w-' + _i + '');

      var _bracketHeight = _el.getAttribute('data-img-h-' + _i + '');

      if (typeof _bracketWidth === 'undefined') {
        break;
      } else {
        if (_width < _bracketWidth) {
          if (_height < _bracketHeight) {
            _src = _el.getAttribute('data-img-s-' + (_i + 1) + '');

            if (typeof _src === 'undefined') {
              _bracket = _i;
            } else {
              _bracket = _i;
            }

            break;
          }
        }
      }

      _bracketCount = _bracketCount + 1;
    }

    if (_bracket === -1) {
      _bracket = _bracketCount;
    }

    _src = _el.getAttribute('data-img-s-' + _bracket + '');

    if (typeof _src === 'undefined') {
      _bracket = _bracket - 1;
      _src = _el.getAttribute('data-img-s-' + _bracket + '');
    }

    return _src;
  }
};
var JumpScroll = {
  init: function init() {
    var _els = document.getElementsByClassName('js-scroll');

    if (_els.length !== 0) {
      for (var _i = 0; _i < _els.length; _i++) {
        if (_els[_i].classList.contains('js-setup') === false) {
          _els[_i].classList.add('js-setup');

          _els[_i].addEventListener('click', function (_evt) {
            _evt.preventDefault();

            var _scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

            anime({
              targets: _scrollElement,
              scrollTop: Math.ceil(Device.screenHeight / 4) * 4 - document.getElementsByClassName('c-site-header')[0].clientHeight + 4,
              duration: 800,
              easing: 'easeInOutQuad'
            });
          });
        }
      }
    }

    _els = document.getElementsByClassName('js-discover-scent');

    if (_els.length !== 0) {
      for (var _i3 = 0; _i3 < _els.length; _i3++) {
        if (_els[_i3].classList.contains('js-setup') === false) {
          _els[_i3].classList.add('js-setup');

          _els[_i3].addEventListener('click', function (_evt) {
            _evt.preventDefault();

            var _scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

            anime({
              targets: _scrollElement,
              scrollTop: Helper.getOffsetTop(document.getElementsByClassName('c-scents')[0]) - document.getElementsByClassName('c-site-header')[0].clientHeight,
              duration: 800,
              easing: 'easeInOutQuad'
            });
          });
        }
      }
    }
  }
};
var Menu = {
  open: false,
  doClick: true,
  pos: 0,
  menuSpeed: 800,
  coverSpeed: 750,
  init: function init() {
    Menu.doToggle();
    Menu.doHover();
    Menu.doSubmenuOpen();
    Menu.doSubmenuClose();
  },
  doToggle: function doToggle() {
    document.getElementsByClassName('js-menu-toggle')[0].addEventListener('click', function (_evt) {
      _evt.preventDefault();

      if (document.body.classList.contains('state-menu-open')) {
        document.body.classList.remove('state-menu-open');
        setTimeout(function () {
          Menu.toggleOpenClasses(-1);
        }, 500);
      } else {
        document.body.classList.add('state-menu-open');

        if (document.body.classList.contains('state-search-open')) {
          document.body.classList.remove('state-search-open');
        }
      }
    });
  },
  doHover: function doHover() {
    var _els = document.getElementsByClassName('c-menu')[0].getElementsByTagName('a');

    for (var _i = 0; _i < _els.length; _i++) {
      _els[_i].setAttribute('data-index', _i);
    }

    if (Device.touch === false) {
      for (var _i4 = 0; _i4 < _els.length; _i4++) {
        _els[_i4].setAttribute('data-index', _i4);

        _els[_i4].addEventListener('mouseover', function (_evt) {
          var _index = parseInt(_evt.currentTarget.getAttribute('data-index'));

          var _links = document.getElementsByClassName('c-menu')[0].getElementsByTagName('a');

          for (var _j = 0; _j < _links.length; _j++) {
            if (parseInt(_links[_j].getAttribute('data-index')) === _index) {
              _links[_j].classList.remove('state-inactive');
            } else {
              _links[_j].classList.add('state-inactive');
            }
          }
        });

        _els[_i4].addEventListener('mouseout', function () {
          var _links = document.getElementsByClassName('c-menu')[0].getElementsByTagName('a');

          for (var _j = 0; _j < _links.length; _j++) {
            _links[_j].classList.remove('state-inactive');
          }
        });
      }
    }
  },
  doSubmenuOpen: function doSubmenuOpen() {
    var _els = document.getElementsByClassName('c-menu')[0].getElementsByClassName('js-parent-link');

    for (var _i = 0; _i < _els.length; _i++) {
      _els[_i].setAttribute('data-parent-index', _i);

      _els[_i].addEventListener('click', function (_evt) {
        _evt.preventDefault();

        var _index = parseInt(_evt.currentTarget.getAttribute('data-parent-index'));

        Menu.toggleOpenClasses(_index);
      });
    }
  },
  doSubmenuClose: function doSubmenuClose() {
    var _els = document.getElementsByClassName('c-menu')[0].getElementsByClassName('js-menu-back');

    for (var _i = 0; _i < _els.length; _i++) {
      _els[_i].addEventListener('click', function (_evt) {
        _evt.preventDefault();

        Menu.toggleOpenClasses(-1);
      });
    }
  },
  toggleOpenClasses: function toggleOpenClasses(_index) {
    for (var _i = 0; _i < 24; _i++) {
      if (_index === _i) {
        document.body.classList.add('state-menu-open-' + _i);
      } else {
        document.body.classList.remove('state-menu-open-' + _i);
      }
    }
  }
};
var FooterMenu = {
  open: false,
  doClick: true,
  pos: 0,
  menuSpeed: 800,
  coverSpeed: 750,
  init: function init() {
    FooterMenu.doHover();
    FooterMenu.doSubmenuOpen();
    FooterMenu.doSubmenuClose();
  },
  doHover: function doHover() {
    var _els = document.getElementsByClassName('c-footer__nav')[0].getElementsByTagName('a');

    for (var _i = 0; _i < _els.length; _i++) {
      _els[_i].setAttribute('data-index', _i);
    }

    if (Device.touch === false) {
      for (var _i5 = 0; _i5 < _els.length; _i5++) {
        _els[_i5].setAttribute('data-index', _i5);

        _els[_i5].addEventListener('mouseover', function (_evt) {
          var _index = parseInt(_evt.currentTarget.getAttribute('data-index'));

          var _links = document.getElementsByClassName('c-footer__nav')[0].getElementsByTagName('a');

          for (var _j = 0; _j < _links.length; _j++) {
            if (parseInt(_links[_j].getAttribute('data-index')) === _index) {
              _links[_j].classList.remove('state-inactive');
            } else {
              _links[_j].classList.add('state-inactive');
            }
          }
        });

        _els[_i5].addEventListener('mouseout', function () {
          var _links = document.getElementsByClassName('c-footer__nav')[0].getElementsByTagName('a');

          for (var _j = 0; _j < _links.length; _j++) {
            _links[_j].classList.remove('state-inactive');
          }
        });
      }
    }
  },
  doSubmenuOpen: function doSubmenuOpen() {
    var _els = document.getElementsByClassName('c-footer__nav')[0].getElementsByClassName('js-parent-link');

    for (var _i = 0; _i < _els.length; _i++) {
      _els[_i].setAttribute('data-parent-index', _i);

      _els[_i].addEventListener('click', function (_evt) {
        _evt.preventDefault();

        var _index = parseInt(_evt.currentTarget.getAttribute('data-parent-index'));

        FooterMenu.toggleOpenClasses(_index);
      });
    }
  },
  doSubmenuClose: function doSubmenuClose() {
    /*		
    let _els = document.getElementsByClassName('c-footer__nav')[0].getElementsByClassName('js-menu-back');
    for (let _i=0;_i<_els.length;_i++) {
    	_els[_i].addEventListener('click',function(_evt){
    		_evt.preventDefault();
    		FooterMenu.toggleOpenClasses(-1);
    	});
    }
    */
  },
  toggleOpenClasses: function toggleOpenClasses(_index) {
    for (var _i = 0; _i < 24; _i++) {
      if (_index === _i) {
        document.body.classList.add('state-footer-menu-open-' + _i);
      } else {
        document.body.classList.remove('state-footer-menu-open-' + _i);
      }
    }
  },
  doResize: function doResize() {
    document.getElementsByClassName('c-footer__nav__list--primary')[0].removeAttribute('style');

    var _els = document.getElementsByClassName('c-footer__nav__list');

    var _height = 0;

    if (_els.length > 0) {
      for (var _i = 0; _i < _els.length; _i++) {
        if (_els[_i].clientHeight > _height) {
          _height = _els[_i].clientHeight;
        }
      }
    }

    document.getElementsByClassName('c-footer__nav__list--primary')[0].style.height = _height + 'px';
  }
};
var Search = {
  open: false,
  doClick: true,
  pos: 0,
  menuSpeed: 800,
  coverSpeed: 750,
  init: function init() {
    Search.doToggle();
  },
  doToggle: function doToggle() {
    var _els = document.getElementsByClassName('js-search-toggle');

    if (_els.length > 0) {
      for (var _i = 0; _i < _els.length; _i++) {
        _els[_i].addEventListener('click', function (_evt) {
          _evt.preventDefault();

          if (document.body.classList.contains('state-search-open')) {
            document.body.classList.remove('state-search-open');
            setTimeout(function () {
              Menu.toggleOpenClasses(-1);
            }, 500);
          } else {
            document.body.classList.add('state-search-open');

            if (document.body.classList.contains('state-menu-open')) {
              document.body.classList.remove('state-menu-open');
            }

            setTimeout(function () {
              document.getElementsByClassName('c-search-modal__input')[0].focus();
            }, 500);
          }
        });
      }

      ;
    }

    ;
  }
};
var Resize = {
  timer: null,
  loop: 0,
  interval: null,
  init: function init() {
    window.addEventListener('resize', Resize.doResize);

    if (document.getElementsByClassName('scope-article-text').length > 0) {
      Resize.interval = setInterval(function () {
        LoadMedia.doResize();
        Format.doResize();
        Scroll.doResize();
        Resize.loop = Resize.loop + 1;

        if (Resize.loop > 120) {
          Resize.clearLoop();
        }
      }, 500);
    }
  },
  clearLoop: function clearLoop() {
    clearInterval(Resize.interval);
    Resize.interval = null;
  },
  doResize: function doResize() {
    Device.refresh();
    LoadMedia.doResize();
    FooterMenu.doResize();
    Format.doResize(); //Menu.doResize();

    Scroll.doResize();
    ProductList.doResize();

    if (Resize.timer !== null) {
      clearTimeout(Resize.timer);
      Resize.timer = null;
    }

    Resize.timer = setTimeout(function () {
      LoadMedia.doResize();
      setTimeout(function () {
        LoadMedia.doResize();
      }, 250);
    }, 800);
  }
};
var Controller = {
  doingResize: false,
  init: function init() {
    Controller.doFrame();
  },
  doFrame: function doFrame() {
    if (Scroll.resizing === false) {
      Scroll.doScroll();
      Scroll.doPage();
      Scroll.doLoad();
      Scroll.doParallax();
      Scroll.doParallaxImg();
    } else {
      Scroll.lastScrollPos = -1;
    }

    requestAnimationFrame(Controller.doFrame);
  }
};

// Disabled by Lightyears
/* This function replaces the mouse cursor, lets stop doing that 
var Mouse = {
  cursor: null,
  mouseActive: false,
  init: function init() {
    if (Device.touch === false) {
      Mouse.cursor = document.getElementsByClassName('js-cursor')[0];
      document.body.addEventListener('mousemove', function (_event) {
        Mouse.cursor.style.top = _event.y + 'px';
        Mouse.cursor.style.left = _event.x + 'px';

        if (Mouse.mouseActive === false) {
          Mouse.mouseActive = true;
          document.body.classList.add('state-show-mouse');
        }
      });
      document.body.addEventListener('mouseleave', function (_event) {
        Mouse.mouseActive = false;
        document.body.classList.remove('state-show-mouse');
      });
    }
  },
  bindEvents: function bindEvents() {
    var _els = document.getElementsByTagName('a');

    if (_els.length > 0) {
      for (var _i = 0; _i < _els.length; _i++) {
        if (_els[_i].classList.contains('js-hover-setup') === false) {
          _els[_i].classList.add('js-hover-setup');

          _els[_i].addEventListener('mouseover', function (_evt) {
            document.body.classList.add('state-mouse-hover');

            if (_evt.currentTarget.classList.contains('js-next')) {
              document.body.classList.add('state-mouse-next');
            }

            if (_evt.currentTarget.classList.contains('js-prev')) {
              document.body.classList.add('state-mouse-prev');
            }
          });

          _els[_i].addEventListener('mouseout', function (_evt) {
            document.body.classList.remove('state-mouse-hover');
            document.body.classList.remove('state-mouse-next');
            document.body.classList.remove('state-mouse-prev');
          });
        }
      }
    }

    _els = document.getElementsByTagName('button');

    if (_els.length > 0) {
      for (var _i6 = 0; _i6 < _els.length; _i6++) {
        if (_els[_i6].classList.contains('js-hover-setup') === false) {
          _els[_i6].classList.add('js-hover-setup');

          _els[_i6].addEventListener('mouseover', function (_evt) {
            document.body.classList.add('state-mouse-hover');
          });

          _els[_i6].addEventListener('mouseout', function (_evt) {
            document.body.classList.remove('state-mouse-hover');
          });
        }
      }
    }
  }
};
*/


/* Accordion scripts */

var Accordion = {
  count: 0,
  init: function init() {
    var _els = document.getElementsByClassName('js-accordion__trigger');

    if (_els.length > 0) {
      for (var _i = 0; _i < _els.length; _i++) {
        Accordion.setup(_els[_i]);
      }
    }
  },
  setup: function setup(_el) {
    if (!_el.classList.contains('js-setup')) {
      var _id = 'accordion-' + Accordion.count;

      _el.classList.add('js-setup');

      var _parent = _el.closest('.js-accordion');

      var _body = _parent.getElementsByClassName('js-accordion__body')[0];

      var _inner = _parent.getElementsByClassName('js-accordion__inner')[0];

      _body.style.overflow = 'hidden';

      _el.setAttribute('role', 'button');

      _el.setAttribute('aria-expanded', 'false');

      _el.setAttribute('aria-controls', _id);

      _body.setAttribute('id', _id);

      _body.setAttribute('aria-hidden', 'true');

      _el.addEventListener('click', function (_evt) {
        _evt.preventDefault();

        var _trigger = this;

        var _parent = _trigger.closest('.js-accordion');

        var _body = _parent.getElementsByClassName('js-accordion__body')[0];

        var _inner = _parent.getElementsByClassName('js-accordion__inner')[0];

        var _height = _inner.clientHeight;

        if (_parent.classList.contains('state-accordion-open') === false) {
          if (_trigger.innerHTML === 'Read More...') {
            _trigger.innerHTML = 'Read Less...';
          }

          _parent.classList.add('state-accordion-open');

          _trigger.classList.add('state-accordion-open');

          _trigger.setAttribute('aria-expanded', 'true');

          _body.setAttribute('aria-hidden', 'false');

          anime({
            targets: _body,
            height: _height,
            duration: 400,
            easing: 'easeInCubic',
            complete: function complete() {
              Resize.doResize();
              _body.style.height = 'auto';

              _parent.classList.add('state-accordion-opened');

              anime({
                targets: _inner,
                opacity: 1,
                duration: 250,
                easing: 'linear'
              });
            }
          });
        } else {
          if (_trigger.innerHTML === 'Read Less...') {
            _trigger.innerHTML = 'Read More...';
          }

          _trigger.setAttribute('aria-expanded', 'false');

          _body.setAttribute('aria-hidden', 'true');

          _parent.classList.remove('state-accordion-open');

          _parent.classList.remove('state-accordion-opened');

          _trigger.classList.remove('state-accordion-open');

          _body.style.height = _height + 'px';
          anime({
            targets: _inner,
            opacity: 0,
            duration: 250,
            easing: 'linear',
            complete: function complete() {
              anime({
                targets: _body,
                height: 0,
                duration: 400,
                easing: 'easeInCubic',
                complete: function complete() {
                  Resize.doResize();
                }
              });
            }
          });
        }
      });

      _inner.style.opacity = 0;
      _body.style.height = '0px';
      Accordion.count = Accordion.count + 1;
    }
  }
};
var ShopView = {
  init: function init() {
    if (document.getElementsByClassName('c-shop-view').length !== 0) {
      document.body.classList.add('state-grid-view');
      document.getElementsByClassName('c-shop-view__filters__grid-filter')[0].addEventListener('click', function (_evt) {
        _evt.preventDefault();

        document.body.classList.add('state-grid-view');
        document.body.classList.remove('state-list-view');
        Resize.doResize();
      });
      document.getElementsByClassName('c-shop-view__filters__list-filter')[0].addEventListener('click', function (_evt) {
        _evt.preventDefault();

        document.body.classList.remove('state-grid-view');
        document.body.classList.add('state-list-view');
        Resize.doResize();
      });
    }
  }
};
/* Helpers - a bunch of helpful functions that can be reused */

var Helper = {
  isVisible: function isVisible(_el) {
    return _el.offsetWidth > 0 && _el.offsetHeight > 0;
  },
  docReady: function docReady(_fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
      setTimeout(_fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", _fn);
    }
  },
  getOffsetLeft: function getOffsetLeft(_el) {
    var _offsetLeft = 0;

    do {
      if (!isNaN(_el.offsetLeft)) {
        _offsetLeft += _el.offsetLeft;
      }
    } while (_el = _el.offsetParent);

    return _offsetLeft;
  },
  getOffsetTop: function getOffsetTop(_el) {
    var _offsetTop = 0;

    do {
      if (!isNaN(_el.offsetTop)) {
        _offsetTop += _el.offsetTop;
      }
    } while (_el = _el.offsetParent);

    return _offsetTop;
  },
  delegate: function delegate(_el, _evt, _sel, _handler) {
    _el.addEventListener(_evt, function (_event) {
      var _t = _event.target;

      while (_t && _t !== this) {
        if (_t.matches(_sel)) {
          _handler.call(_t, _event);
        }

        _t = _t.parentNode;
      }
    });
  }
};
var SwiperGallery = {
  swiper: null,
  total: 0,
  init: function init() {
    if (document.getElementsByClassName('swiper').length !== 0) {
      SwiperGallery.total = document.getElementsByClassName('swiper-slide').length;
      SwiperGallery.swiper = new Swiper('.swiper', {
        loop: false,
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          init: SwiperGallery.updSwiperNumericPagination,
          slideChange: SwiperGallery.updSwiperNumericPagination
        }
      });
    }
  },
  updSwiperNumericPagination: function updSwiperNumericPagination() {
    this.el.querySelector(".swiper-counter").innerHTML = '<span class="count">' + (this.realIndex + 1) + '</span>/<span class="total">' + SwiperGallery.total + "</span>";
  }
};
var FadeGallery = {
  glide: [],
  init: function init() {
    if (document.getElementsByClassName('scope-fade-gallery').length !== 0) {
      for (var _i = 0; _i < document.getElementsByClassName('scope-fade-gallery').length; _i++) {
        FadeGallery.initFadeGallery(document.getElementsByClassName('scope-fade-gallery')[_i].getElementsByClassName('glide')[0]);
      }

      FadeGallery.checkFadeGalleryIndex();
    }
  },
  initFadeGallery: function initFadeGallery(_el) {
    var _index = FadeGallery.glide.length;

    _el.closest('.scope-fade-gallery').setAttribute('data-glide-index', _index);

    FadeGallery.glide[_index] = new Glide(_el, {
      'type': 'carousel',
      'gap': 0,
      'animationDuration': 0
    });

    FadeGallery.glide[_index].on('run', function (_evt) {
      FadeGallery.checkFadeGalleryIndex();
    });

    FadeGallery.glide[_index].mount();

    var _dots = _el.closest('.scope-fade-gallery').getElementsByClassName('js-dot-control');

    if (_dots.length > 0) {
      for (var _j = 0; _j < _dots.length; _j++) {
        if (_j === 0) {
          _dots[_j].classList.add('state-active');
        }

        _dots[_j].addEventListener('click', function (_evt) {
          _evt.preventDefault();

          var _index = parseInt(_evt.currentTarget.getAttribute('data-index'));

          var _galleryIndex = parseInt(_evt.currentTarget.closest('.scope-fade-gallery').getAttribute('data-glide-index'));

          FadeGallery.glide[_galleryIndex].go('=' + _index);
        });
      }
    }

    var _next = _el.closest('.scope-fade-gallery').getElementsByClassName('js-next');

    if (_next.length > 0) {
      _next[0].addEventListener('click', function (_evt) {
        _evt.preventDefault();

        var _galleryIndex = parseInt(_evt.currentTarget.closest('.scope-fade-gallery').getAttribute('data-glide-index'));

        FadeGallery.glide[_galleryIndex].go('>');
      });
    }
  },
  checkFadeGalleryIndex: function checkFadeGalleryIndex() {
    setTimeout(function () {
      var _els = document.getElementsByClassName('glide');

      if (_els.length > 0) {
        for (var _i = 0; _i < _els.length; _i++) {
          var _index = FadeGallery.glide[_i].index;

          var _dots = document.getElementsByClassName('js-dot-control');

          if (_dots.length > 0) {
            for (var _j = 0; _j < _dots.length; _j++) {
              if (_j === _index) {
                _dots[_j].classList.add('state-active');
              } else {
                _dots[_j].classList.remove('state-active');
              }
            }

            _index = _index + 1;

            var _counter = _els[_i].closest('.scope-fade-gallery').getElementsByClassName('gallery-current')[0];

            if (_counter.innerHTML !== _index) {
              _counter.innerHTML = _index;
            }
          }

          if (_els[_i].closest('.scope-fade-gallery').getElementsByClassName('gallery-text').length > 0) {
            (function () {
              var _textEl = _els[_i].closest('.scope-fade-gallery').getElementsByClassName('gallery-text')[0];

              var _text = _els[_i].closest('.scope-fade-gallery').getElementsByClassName('glide__slide')[_index].getAttribute('data-text');

              _els[_i].closest('.scope-fade-gallery').classList.add('state-transition-text');

              setTimeout(function () {
                _textEl.innerHTML = _text;
                document.getElementsByClassName('scope-fade-gallery')[0].classList.remove('state-transition-text');
              }, 200);
            })();
          }
        }
      }
    }, 10);
  }
};
var CheckLinks = {
  init: function init() {
    if (document.getElementsByClassName('c-site-header__logo__inner').length > 0) {
      var _url = document.getElementsByClassName('c-site-header__logo__inner')[0].getAttribute('href');

      var _links = document.getElementsByTagName('a');

      for (var _i = 0; _i < _links.length; _i++) {
        try {
          if (_links[_i].getAttribute('href').indexOf(_url) === -1 && _links[_i].getAttribute('href').indexOf('/') !== 0 && _links[_i].getAttribute('href') !== '#') {
            _links[_i].setAttribute('target', '_blank');
          }
        } catch (_e) {}
      }
    }
  }
};
var Format = {
  init: function init() {
    if (document.getElementsByTagName('section')[0].classList.contains('c-splash')) {
      document.body.classList.add('state-reverse-header');
    }

    var _els = document.getElementsByClassName('c-product__description');

    if (_els.length > 0) {
      for (var _i = 0; _i < _els.length; _i++) {
        var _textNodes = _els[_i].children;
        var _accordionHTML = '';
        var _textHTML = '';

        for (var _j = 0; _j < _textNodes.length; _j++) {
          _textNodes[_j];

          var _string = _textNodes[_j].innerHTML.replace('<strong></strong>', '').replace('<strong> </strong>', '');

          _textNodes[_j].innerHTML = _string;

          if (_string.includes("</strong>")) {
            if (_string.includes("Price")) {} else {
              var _title = _textNodes[_j].getElementsByTagName('strong')[0].innerHTML.replace(':&nbsp;', '').replace(':', '');

              var _paragraph = Format.stripStrong(_string);

              if (_j < _textNodes.length - 1) {
                if (_textNodes[_j + 1].getElementsByTagName('strong').length == 0) {
                  _paragraph = _paragraph + '<p>' + _textNodes[_j + 1].innerHTML + '</p>';
                  _textNodes[_j + 1].innerHTML = '';
                }
              }

              if (_j < _textNodes.length - 2) {
                if (_textNodes[_j + 2].getElementsByTagName('strong').length == 0) {
                  _paragraph = _paragraph + '<p>' + _textNodes[_j + 2].innerHTML + '</p>';
                  _textNodes[_j + 2].innerHTML = '';
                }
              }

              if (_title !== '') {
                _accordionHTML += '<div class="js-accordion">';
                _accordionHTML += '<a href="#" class="js-accordion__trigger">' + _textNodes[_j].getElementsByTagName('strong')[0].innerHTML.replace(':&nbsp;', '').replace(':', '') + '</a>';
                _accordionHTML += '<div class="js-accordion__body"><div class="js-accordion__inner"><div class="scope-text"><p>';
                _accordionHTML += _paragraph;
                _accordionHTML += '</p></div></div></div>';
                _accordionHTML += '</div>';
              }
            }
          } else if (_string === '') {
            /* do nothing */
          } else {
            _textHTML += '<p>' + _string + '</p>';
          }
        }

        if (_accordionHTML !== '') {
          document.getElementsByClassName('c-product__info__accordions')[0].innerHTML = _accordionHTML;
        }

        _els[_i].innerHTML = _textHTML;
        _textNodes = _els[_i].getElementsByTagName('p');

        if (_textNodes.length > 2) {
          var _html = '<p>' + _textNodes[0].innerHTML + '</p><p>' + _textNodes[1].innerHTML + '</p>';

          _html = _html + '<div class="js-accordion"><div class="js-accordion__body"><div class="js-accordion__inner">';

          for (var _j3 = 0; _j3 < _textNodes.length - 2; _j3++) {
            _html = _html + '<p>' + _textNodes[_j3 + 2].innerHTML + '</p>';
          }

          _html = _html + '</div></div><a href="#" class="js-accordion__trigger">Read More...</a></div>';
          _els[_i].innerHTML = _html;
        }
      }
    }

    Format.doResize();
  },
  stripStrong: function stripStrong(html) {
    var span = document.createElement('span');
    span.innerHTML = html;

    _toConsumableArray(span.getElementsByTagName('strong')).reverse().forEach(function (strong) {
      return strong.parentNode.removeChild(strong);
    });

    return span.innerHTML;
  },
  doResize: function doResize() {
    if (document.getElementsByClassName('scope-article-text').length > 0) {
      var _p = document.getElementsByClassName('scope-article-text')[0].querySelectorAll('p,ul,ol,h1,h2,h3,h4,h5,h6');

      var _count = 0;
      var _imgfound = false;
      var _gallery = [];

      if (_p.length > 0) {
        for (var _i = 0; _i < _p.length; _i++) {
          if (!_p[_i].classList.contains('state-in-gallery')) {
            if (_p[_i].getElementsByTagName('img').length > 0) {
              _imgfound = true;

              _p[_i].classList.add('state-contains-media');

              if (_count === 0 && _p[_i].clientWidth > _p[_i].clientHeight && _p[_i].clientHeight > 48) {
                _p[_i].classList.add('state-wide-image');

                _gallery.push(_p[_i]);
              } else {
                _p[_i].classList.remove('state-wide-image');

                _p[_i].classList.add('state-right-aligned');

                _gallery.push(_p[_i]);
              }

              _count = _count + 1;
            } else {
              if (_gallery.length > 1) {
                Format.insertGallery(_gallery);
              }

              _gallery = [];

              if (_p[_i].innerHTML == '&nbsp;') {
                _p[_i].classList.add('state-hide-text');
              }

              if (_imgfound === false) {
                _p[_i].classList.add('state-left-aligned');
              } else {
                _p[_i].classList.add('state-right-aligned');
              }
            }
          }
        }

        if (_gallery.length > 1) {
          Format.insertGallery(_gallery);
        }

        _gallery = [];
      }
    }
  },
  insertGallery: function insertGallery(_gallery) {
    var _html = '<div class="scope-fade-gallery"><div class="glide-outer-wrapper"><div class="glide-wrapper"><div class="glide js-fade-gallery"><div class="glide__track" data-glide-el="track"><div class="glide__slides">';

    for (var _i = 0; _i < _gallery.length; _i++) {
      _html = _html + '<div class="glide__slide"><div class="glide__slide__inner">';
      _html = _html + _gallery[_i].getElementsByTagName('img')[0].outerHTML;
      _html = _html + '</div></div>';
    }

    _html = _html + '</div></div></div><a href="#" class="js-next"></a></div></div>';
    _html = _html + '<div class="gallery-footer">';
    _html = _html + '<div class="counter"><p class="gallery-current">1</p>/<p class="gallery-total">' + _gallery.length + '</p></div>';
    _html = _html + '<ul class="controls">';

    for (var _i7 = 0; _i7 < _gallery.length; _i7++) {
      _html = _html + '<li><a href="#" class="js-dot-control" data-index="' + _i7 + '"></a></li>';
    }

    _html = _html + '</ul>';
    _html = _html + '</div>';
    _html = _html + '</div>';

    _gallery[0].insertAdjacentHTML('beforebegin', _html);

    for (var _i8 = 0; _i8 < _gallery.length; _i8++) {
      _gallery[_i8].classList.add('state-in-gallery');
    }
  }
};
var Brands = {
  timer: null,
  init: function init() {
    if (document.getElementsByClassName('c-brands__masonry').length !== 0) {
      var _grid = document.querySelector('.c-brands__masonry__wrapper');

      var _msnry = new Masonry(_grid, {
        percentPosition: true,
        resize: true
      });

      var _els = document.getElementsByClassName('c-brands__masonry__wrapper')[0].getElementsByTagName('a');

      for (var _i = 0; _i < _els.length; _i++) {
        if (Device.touch === false) {
          _els[_i].addEventListener('mouseover', function (_evt) {
            if (Brands.timer !== null) {
              clearTimeout(Brands.timer);
              Brands.timer = null;
            }

            var _index = _evt.currentTarget.getAttribute('data-index');

            var _thumbs = document.getElementsByClassName('c-brands__masonry__wrapper')[0].getElementsByTagName('a');

            for (var _j = 0; _j < _thumbs.length; _j++) {
              if (_thumbs[_j].getAttribute('data-index') === _index) {
                _thumbs[_j].classList.remove('state-inactive');
              } else {
                _thumbs[_j].classList.add('state-inactive');
              }
            }

            var _heading = _evt.currentTarget.getAttribute('data-heading');

            var _count = _evt.currentTarget.getAttribute('data-count');

            document.getElementsByClassName('c-brands__overlay__heading')[0].innerHTML = _heading + '<sup>' + _count + '</sup>';
            document.getElementsByClassName('c-brands__overlay')[0].classList.add('state-active');
          });

          _els[_i].addEventListener('mouseout', function (_evt) {
            if (Brands.timer !== null) {
              clearTimeout(Brands.timer);
              Brands.timer = null;
            }

            Brands.timer = setTimeout(function () {
              var _thumbs = document.getElementsByClassName('c-brands__masonry__wrapper')[0].getElementsByTagName('a');

              for (var _j = 0; _j < _thumbs.length; _j++) {
                _thumbs[_j].classList.remove('state-inactive');
              }

              document.getElementsByClassName('c-brands__overlay')[0].classList.remove('state-active');
            }, 250);
          });
        }
      }

      document.body.classList.add('state-list-view');
      document.getElementsByClassName('c-brands__filters__grid-filter')[0].addEventListener('click', function (_evt) {
        _evt.preventDefault();

        document.body.classList.add('state-grid-view');
        document.body.classList.remove('state-list-view');
        window.dispatchEvent(new Event('resize'));
        setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
        }, 0);
        setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
        }, 800);
      });
      document.getElementsByClassName('c-brands__filters__list-filter')[0].addEventListener('click', function (_evt) {
        _evt.preventDefault();

        document.body.classList.remove('state-grid-view');
        document.body.classList.add('state-list-view');
        window.dispatchEvent(new Event('resize'));
        setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
        }, 0);
        setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
        }, 800);
      });
    }
  }
};
var HoverEffect = {
  timer: null,
  init: function init() {
    if (Device.touch === false) {
      var _els = document.getElementsByClassName('js-hover-effect');

      if (_els.length > 0) {
        for (var _i = 0; _i < _els.length; _i++) {
          _els[_i].addEventListener('mouseover', function (_evt) {
            HoverEffect.clearTimer();

            var _links = _evt.currentTarget.closest('.js-hover-effect-parent').getElementsByClassName('js-hover-effect');

            for (var _j = 0; _j < _links.length; _j++) {
              _links[_j].classList.remove('state-active-link');

              _links[_j].classList.add('state-inactive-link');
            }

            _evt.currentTarget.classList.remove('state-inactive-link');

            _evt.currentTarget.classList.add('state-active-link');
          });

          _els[_i].addEventListener('mouseout', function (_evt) {
            HoverEffect.clearTimer();
            HoverEffect.timer = setTimeout(function () {
              var _links = document.getElementsByClassName('js-hover-effect');

              for (var _j = 0; _j < _links.length; _j++) {
                _links[_j].classList.remove('state-active-link');

                _links[_j].classList.remove('state-inactive-link');
              }
            }, 250);
          });
        }
      }
    }
  },
  clearTimer: function clearTimer() {
    if (HoverEffect.timer !== null) {
      clearTimeout(HoverEffect.timer);
      HoverEffect.timer = null;
    }
  }
};
var Cart = {
  currentTotal: 0,
  timer: null,
  init: function init() {
    Cart.currentTotal = parseInt(document.getElementsByClassName('js-cart-count')[0].innerHTML);
    Cart.checkCartStatus();
    Cart.initQtyUpdate();
    // Cart.initAdd();
  },
  initQtyUpdate: function initQtyUpdate() {
    if (document.getElementById('cart')) {
      var _els = document.getElementById('cart').getElementsByClassName('js-cart-qty');

      if (_els.length !== 0) {
        for (var _i = 0; _i < _els.length; _i++) {
          _els[_i].addEventListener('change', function (_evt) {
            Cart.checkQty(_evt.target, false);
          });
        }
      }

      _els = document.getElementById('cart').getElementsByClassName('js-cart-remove');

      if (_els.length !== 0) {
        for (var _i9 = 0; _i9 < _els.length; _i9++) {
          _els[_i9].addEventListener('click', function (_evt) {
            _evt.preventDefault();

            var _item = this.closest('.c-cart__tr');

            _item.getElementsByClassName('js-cart-qty')[0].value = 0;
            Cart.checkQty(_item.getElementsByClassName('js-cart-qty')[0], false);
          });
        }
      }
    }
  },
  checkQty: function checkQty(_el, _success) {
    var _object = {};
    _object['quantity'] = parseInt(_el.value);
    _object['line'] = parseInt(_el.getAttribute('data-index'));

    var _json = JSON.stringify(_object);

    var _xhr = new XMLHttpRequest();

    _xhr.onreadystatechange = function () {
      if (_xhr.readyState === 4) {
        if (_success === true) {
          Cart.reformatCart(_xhr.responseText, true);
        } else {
          Cart.reformatCart(_xhr.responseText, false);
        }

        Cart.checkCartStatus();
      }
    };

    _xhr.open("POST", '/cart/change.js', true);

    _xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

    _xhr.send(_json);
  },
  reformatCart: function reformatCart(_json, _successBanner) {
    if (_json) {
      var _data = JSON.parse(_json);

      var _els = document.getElementsByClassName('c-cart__tr');

      var _index = 0;

      if (_data['items']) {
        var _total = parseInt(_data['total_price']);

        var _items = parseInt(_data['item_count']);

        var _counts = document.getElementsByClassName('js-cart-count');

        if (_counts.length > 0) {
          for (var _i = 0; _i < _counts.length; _i++) {
            _counts[_i].innerHTML = parseInt(_items);
          }
        }

        Cart.currentTotal = parseInt(_items);

        if (Cart.currentTotal === 0) {
          window.location.reload();
        } else {
          var _els2 = document.getElementsByClassName('c-cart__tr');

          for (var _j = 0; _j < _els2.length; _j++) {
            _els2[_j].classList.remove('state-match');
          }

          if (_els2.length !== 0) {
            for (var _i10 = 0; _i10 < _data['items'].length; _i10++) {
              var _key = _data['items'][_i10]['key'];

              for (var _j4 = 0; _j4 < _els2.length; _j4++) {
                if (_els2[_j4].getAttribute('data-key') == _key) {
                  var _quantity = _data['items'][_i10]['quantity'];

                  var _input = _els2[_j4].getElementsByClassName('js-cart-qty')[0];

                  var _inputKey = _input.getAttribute('data-key');

                  _input.value = _quantity;

                  if (parseInt(_input.value) === 0) {
                    _els2[_j4].style.display = 'none';
                  } else {
                    _els2[_j4].classList.add('state-match');

                    _els2[_j4].getElementsByClassName('js-line-total')[0].innerHTML = '$' + _data['items'][_i10]['line_price'] / 100;
                  }
                }
              }
            }
          }

          for (var _j5 = 0; _j5 < _els2.length; _j5++) {
            if (!_els2[_j5].classList.contains('state-match') && !_els2[_j5].classList.contains('c-cart__tr--footer')) {
              _els2[_j5].style.display = 'none';
            }
          }

          if (document.getElementsByClassName('js-total').length) {
            document.getElementsByClassName('js-total')[0].innerHTML = '$' + _data['items_subtotal_price'] / 100;
          }
        }
      }
    }
  },
  initAdd: function initAdd() {
    if (document.getElementsByClassName('shopify-product-form').length !== 0) {
      
      document.getElementsByClassName('shopify-product-form')[0].addEventListener('submit', function (_evt) {
        Cart.currentTotal = parseInt(document.getElementsByClassName('js-cart-count')[0].innerHTML);

        _evt.preventDefault();

        var _data = new FormData(this);

        var _object = {};

        _data.forEach(function (_value, _key) {
          _object[_key] = _value;
        });

        var _json = JSON.stringify(_object);

        var _xhr = new XMLHttpRequest();

        _xhr.onreadystatechange = function () {
          if (_xhr.readyState === 4) {
            var _temp = document.createElement("DIV");

            _temp.innerHTML = _xhr.responseText;

            if (_temp.getElementsByClassName('c-cart__wrapper').length !== 0 && document.getElementsByClassName('c-cart__wrapper').length !== 0) {
              document.getElementsByClassName('c-cart__wrapper')[0].innerHTML = _temp.getElementsByClassName('c-cart__wrapper')[0].innerHTML;
              Cart.initQtyUpdate();
            }

            Resize.doResize();

            var _success = document.getElementById('js-product-title').innerHTML + ' added to your cart';

            document.getElementById('js-cart-notification').innerHTML = _success;

            var _qtyEls = document.getElementsByClassName('c-cart__item__form__qty');

            if (_qtyEls.length > 0) {
              for (var _k = 0; _k < _qtyEls.length; _k++) {
                Cart.checkQty(document.getElementsByClassName('c-cart__item__form__qty')[_k], true);
              }
            }

            if (Cart.timer !== null) {
              clearTimeout(Cart.timer);
            }

            // document.getElementsByClassName('js-cart-count')[0].innerHTML = _temp.getElementsByClassName('js-cart-count')[0].innerHTML;
            // I think I'm handling this now.

            /*
            if (Cart.currentTotal === parseInt(_temp.getElementsByClassName('js-cart-count')[0].innerHTML)) {
              alert('Sorry, we could not add any more of this product to your cart as stock is limited.');
            } else {
              Cart.currentTotal = parseInt(_temp.getElementsByClassName('js-cart-count')[0].innerHTML);
            }
            */

            Resize.doResize();
          }
        };

        _xhr.open("POST", this.getAttribute('action'), true);

        _xhr.setRequestHeader('Content-Type', 'application/json');

        _xhr.send(_json);
      });
    }
  },
  checkCartStatus: function checkCartStatus() {
    var _els = document.getElementsByClassName('c-cart__item__form__qty');

    if (_els.length !== 0) {
      for (var _i = 0; _i < _els.length; _i++) {
        if (parseInt(_els[_i].value) === 0) {
          _els[_i].closest('.c-cart__item').remove();
        }
      }
    }

    _els = document.getElementsByClassName('js-cart-count');

    if (_els.length > 0) {
      for (var _i11 = 0; _i11 < _els.length; _i11++) {
        if (parseInt(_els[_i11].innerHTML) !== 0) {
          _els[_i11].parentNode.classList.add('state-active');

          document.body.classList.remove('state-no-items');
        } else {
          _els[_i11].parentNode.classList.remove('state-active');

          document.body.classList.add('state-no-items');
        }
      }
    }
  }
};
var NumberInput = {
  init: function init() {
    var _els = document.getElementsByClassName('js-number-input');

    if (_els.length > 0) {
      for (var _i = 0; _i < _els.length; _i++) {
        if (_els[_i].classList.contains('js-setup') === false) {
          _els[_i].classList.add('js-setup');

          _els[_i].getElementsByClassName('js-number-input__field')[0].addEventListener('keyup', function (_evt) {
            NumberInput.checkValues();
          });

          if (_els[_i].getElementsByClassName('c-number-input__plus').length > 0) {
            _els[_i].getElementsByClassName('c-number-input__plus')[0].addEventListener('click', function (_evt) {
              _evt.preventDefault();

              _evt.currentTarget.closest('.js-number-input').getElementsByClassName('js-number-input__field')[0].value = parseInt(_evt.currentTarget.closest('.js-number-input').getElementsByClassName('c-number-input__field')[0].value) + 1;
              NumberInput.checkValues();
            });

            _els[_i].getElementsByClassName('c-number-input__minus')[0].addEventListener('click', function (_evt) {
              _evt.preventDefault();

              _evt.currentTarget.closest('.js-number-input').getElementsByClassName('js-number-input__field')[0].value = parseInt(_evt.currentTarget.closest('.js-number-input').getElementsByClassName('js-number-input__field')[0].value) - 1;
              NumberInput.checkValues();
            });
          }
        }
      }
    }
  },
  checkValues: function checkValues() {
    var _els = document.getElementsByClassName('js-number-input');

    var getnearbyqtynote = document.querySelector('#qtynote');

    if (_els.length > 0) {
      for (var _i = 0; _i < _els.length; _i++) {
        var _value = _els[_i].getElementsByClassName('js-number-input__field')[0].value;

        var _max = parseInt(_els[_i].getElementsByClassName('js-number-input__field')[0].getAttribute('data-max'));

        var _maxavail = parseInt(_els[_i].getElementsByClassName('js-number-input__field')[0].getAttribute('data-availableqty'));

        var _newValue = _value.replace(/\D/g, '');

        if (_newValue === '') {
          _newValue = '1';
        }

        if (_newValue === '0') {
          _newValue = '1';
        }

        if (parseInt(_newValue) > _max) {
          _newValue = _max;
          console.log("hitmax");
          if(getnearbyqtynote) {
            getnearbyqtynote.style.display = 'block';
          }
        }

        if(getnearbyqtynote) {
          if (parseInt(_newValue) > _maxavail && _maxavail != 0) {
            getnearbyqtynote.style.display = 'block';
          } else {
            getnearbyqtynote.style.display = 'none';
          }
        }

        if (_value !== _newValue) {
          _els[_i].getElementsByClassName('js-number-input__field')[0].value = _newValue;
        }
      }
    }
  }
};
var ProductList = {
  doResize: function doResize() {
    var _lists = document.getElementsByClassName('c-product-text-list');

    if (_lists.length > 0) {
      for (var _i = 0; _i < _lists.length; _i++) {
        var _items = _lists[_i].getElementsByClassName('c-product-text-list__item');

        if (_items.length > 0) {
          var _left = _items[0].offsetLeft;
          var _top = _items[0].offsetTop;

          for (var _j = 1; _j < _items.length; _j++) {
            var _thisTop = _items[_j].offsetTop;

            if (_top != _thisTop) {
              _top = _thisTop;

              _items[_j - 1].classList.add('state-last-item');
            } else {
              _items[_j - 1].classList.remove('state-last-item');
            }
          }

          _items[_items.length - 1].classList.add('state-last-item');
        }
      }
    }
  }
};
var HoverImage = {
  html: '',
  timer: null,
  init: function init() {
    var els = document.getElementsByClassName('c-product-text-list__link');

    if (els.length > 0) {
      for (var i = 0; i < els.length; i++) {
        els[i].innerHTML = els[i].innerHTML + '<div><img src="' + els[i].getAttribute('data-thumb') + '" /></div>';
      }
    }
  }
};
var Enquire = {
  init: function init() {
    var _els = document.getElementsByClassName('js-toggle-enquire');

    if (_els.length > 0) {
      for (var _i = 0; _i < _els.length; _i++) {
        _els[_i].addEventListener('click', function (_evt) {
          _evt.preventDefault();

          if (document.documentElement.classList.contains('state-enquire-open')) {
            document.documentElement.classList.remove('state-enquire-open');
          } else {
            document.documentElement.classList.add('state-enquire-open');
          }
        });
      }
    }

    var location = window.location + '';

    if (location.indexOf('?contact_posted=true#contact_form') !== -1 && location.indexOf('/products/') !== -1) {
      document.documentElement.classList.add('state-enquire-open');
    }
  }
};
var VideoCheck = {
  init: function init() {
    if (document.getElementsByClassName('js-video-check')) {
      var _els = document.getElementsByClassName('js-video-check');

      for (var _i = 0; _i < _els.length; _i++) {
        if (_els[_i].classList.contains('js-video-check--portrait') && window.innerWidth > window.innerHeight) {
          _els[_i].innerHTML = '';
        }

        if (_els[_i].classList.contains('js-video-check--landscape') && window.innerWidth < window.innerHeight) {
          _els[_i].innerHTML = '';
        }
      }
    }
  }
};
var Gallery = {
  scrollPos: 0,
  open: false,
  init: function init() {
    if (document.getElementsByClassName('c-gallery__slider').length > 0) {
      Gallery.bindThumbs();
      Gallery.bindBack();
    }
  },
  bindThumbs: function bindThumbs() {
    var _els = document.getElementsByClassName('c-gallery__thumb');

    for (var _i = 0; _i < _els.length; _i++) {
      _els[_i].addEventListener('click', function (_evt) {
        _evt.preventDefault();

        Gallery.scrollPos = Scroll.scrollPos;
        FadeGallery.glide[0].go('=' + parseInt(_evt.currentTarget.getAttribute('data-index')));
        document.body.classList.add('state-gallery-open');
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
    }
  },
  bindBack: function bindBack() {
    document.getElementsByClassName('c-gallery__back')[0].addEventListener('click', function (_evt) {
      _evt.preventDefault();

      document.body.classList.remove('state-gallery-open');
      window.scrollTo({
        top: Gallery.scrollPos,
        behavior: "smooth"
      });
    });
  }
};
/* Boot - boot the site when the DOM is ready */

var Boot = {
  loaderEl: null,
  startPercent: 25,
  endPercent: 25,
  pageLoaded: false,
  site: function site() {
    Boot.loaderEl = document.getElementsByClassName('c-page-loader')[0];
    setTimeout(function () {
      window.scrollTo(0, 0);
      Device.init();
      VideoCheck.init();
      Format.init();
      Accordion.init();
      Menu.init();
      FooterMenu.init();
      Search.init();
      Cart.init();
      NumberInput.init();
      FadeGallery.init();
      SwiperGallery.init();
      HoverImage.init();
      ShopView.init();
      CheckLinks.init();
      HoverEffect.init();
      Brands.init();
      Scroll.init();
      Controller.init();
      JumpScroll.init();
      Accordion.init();
      Resize.init();
      Resize.doResize();
      Boot.checkLoader();
      LoadMedia.loadFirst();
      // Mouse.init(); // Disabled by Lightyears
      Enquire.init();
      Gallery.init();
    }, 100);
  },
  checkLoader: function checkLoader() {
    if (document.body.classList.contains('state-page-loaded') === false) {
      Boot.loaderEl.style.width = Boot.startPercent + '%';

      var _els = document.getElementsByClassName('js-state-load-first');

      var _speed = 100;

      if (_els) {
        var _count = 0;
        var _done = true;

        for (var _i = 0; _i < _els.length; _i++) {
          if (_els[_i].classList.contains('state-media-loaded') === false) {
            _done = false;
          } else {
            _count = _count + 1;
          }
        }

        if (_done === true) {
          Boot.loaderEl.style.width = '100%';
          setTimeout(function () {
            window.scrollTo(0, 0);
            Boot.loaderEl.style.left = 'auto';
            Boot.loaderEl.style.right = 0;
            Boot.loaderEl.style.width = '0%';
            Resize.doResize();
            document.body.classList.add('state-site-loaded');
            document.body.classList.add('state-page-loaded');
            Boot.pageLoaded = true;
            // Mouse.bindEvents();
          }, _speed);
        } else {
          Boot.loaderEl.style.width = Boot.startPercent + (100 - Boot.startPercent - Boot.endPercent) / _els.length * _count + '%';
        }
      } else {
        Boot.loaderEl.style.width = '100%';
        setTimeout(function () {
          window.scrollTo(0, 0);
          Boot.loaderEl.style.left = 'auto';
          Boot.loaderEl.style.right = 0;
          Boot.loaderEl.style.width = '0%';
          Resize.doResize();
          document.body.classList.add('state-site-loaded');
          document.body.classList.add('state-page-loaded');
          Boot.pageLoaded = true;
          // Mouse.bindEvents();
          NumberInput.init();
        }, _speed);
      }
    }
  }
};
/* Abracadabra */

Helper.docReady(Boot.site);

//# sourceMappingURL=main-min.js.map
